// extracted by mini-css-extract-plugin
export default {"customRadioGroup":"CustomRadioGroup_customRadioGroup__tdSY3","customRadioGroupItem":"CustomRadioGroup_customRadioGroupItem__wY5QD","active":"CustomRadioGroup_active__xcUX5"};